import React, { useState } from "react";

export const ButtonRectangle = ({
  colorButton,
  newColorButton,
  complementaryText,
  onClickEvent,
  pokename,
  individualDataPokemon,
  /* variable contenedora para actulizar el estado de urlMainDetails */
  setMainDetailsURL,
  setIdMain,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  let baseColor = colorButton === "green" ? "green" : "red";
  if (newColorButton) {
    baseColor = newColorButton;
  }

  const style = {
    backgroundColor: isHovered
      ? baseColor === "green"
        ? "darkgreen"
        : baseColor === "red"
        ? "darkred"
        : `dark${baseColor}` // Si es otro color, oscurecerlo
      : baseColor,
    color: "white",
    transition: "background-color 0.3s ease",
  };

  const passStatics = () => {
    setMainDetailsURL(individualDataPokemon);
    setIdMain(individualDataPokemon?.id);
  };
  return (
    <div>
      <button
        onClick={() => {
          passStatics();
          onClickEvent();
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={style}
        className="button-rectangle"
      >
        {complementaryText}
      </button>
    </div>
  );
};

export default ButtonRectangle;

/* Este boton responde a mostrar los detalles del pokemon */
